import { render } from "./TestPageDetail.vue?vue&type=template&id=455b2ddc&scoped=true"
import script from "./TestPageDetail.vue?vue&type=script&lang=js"
export * from "./TestPageDetail.vue?vue&type=script&lang=js"

import "./TestPageDetail.vue?vue&type=style&index=0&id=455b2ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b2ddc"]])

export default __exports__